import { Document } from "@react-pdf/renderer";
import React from "react";
import PageLayout from "./pages/PageLayout";
import Page1 from "./pages/Page1";
import Page2 from "./pages/Page2";
import Page3 from "./pages/Page3";
import Page4 from "./pages/Page4";

export default function CostPlusPdf({
  generatedTitles,
  quotationDetails,
  FEES_PAYABLE,
  MUQEEM_POINTS,
  QUOTATION,
  combinedData,
  TERMS,
  NOTES,
}) {
  console.log(".............mmmmmmmm.........check...",generatedTitles)
  return (
    <Document>
      <PageLayout pageNo={1}>
        <Page1 QUOTATION={QUOTATION} />
      </PageLayout>
      <PageLayout pageNo={2}>
        <Page2
          generatedTitles={generatedTitles}
          FEES_PAYABLE={FEES_PAYABLE}
          QUOTATION={QUOTATION}
          combinedData={combinedData}
        />
        {/* </PageLayout>
      <PageLayout pageNo={3}> */}
        <Page3 MUQEEM_POINTS={MUQEEM_POINTS} />
        {/* </PageLayout>
      <PageLayout pageNo={4}> */}
        <Page4 TERMS={TERMS} notes={NOTES} />
      </PageLayout>
    </Document>
  );
}
